import { NgModule } from '@angular/core';

import { SharedModule } from 'cbc-shared-lib';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';
import { NumberInputDirective } from '../sg-ke-shared/directives/number-input.directive';
import { Sgke010dSearchConditionComponent } from './pages/sgke010d/components/sgke010d-search-condition/sgke010d-search-condition.component';
import { Sgke010dSearchResultComponent } from './pages/sgke010d/components/sgke010d-search-result/sgke010d-search-result.component';
import { Sgke010dComponent } from './pages/sgke010d/pages/sgke010d/sgke010d.component';
import { Sgke020dBusinessTypeComponent } from './pages/sgke020d/components/sgke020d-business-type/sgke020d-business-type.component';
import { Sgke020dComponent } from './pages/sgke020d/pages/sgke020d/sgke020d.component';
import { Sgke030dSearchResultComponent } from './pages/sgke030d/components/sgke030d-search-result/sgke030d-search-result.component';
import { Sgke030dViewComponent } from './pages/sgke030d/components/sgke030d-view/sgke030d-view.component';
import { Sgke030dComponent } from './pages/sgke030d/pages/sgke030d/sgke030d.component';
import { Sgke040dSearchConditionComponent } from './pages/sgke040d/components/sgke040d-search-condition/sgke040d-search-condition.component';
import { Sgke040dSearchResultComponent } from './pages/sgke040d/components/sgke040d-search-result/sgke040d-search-result.component';
import { Sgke040dViewComponent } from './pages/sgke040d/components/sgke040d-view/sgke040d-view.component';
import { Sgke040dComponent } from './pages/sgke040d/pages/sgke040d/sgke040d.component';
import { Sgke050dDialogComponent } from './pages/sgke050d/components/sgke050d-dialog/sgke050d-dialog.component';
import { Sgke050dRegistComponent } from './pages/sgke050d/components/sgke050d-regist/sgke050d-regist.component';
import { Sgke050dComponent } from './pages/sgke050d/pages/sgke050d/sgke050d.component';
import { Sgke060dRegistComponent } from './pages/sgke060d/components/sgke060d-regist/sgke060d-regist.component';
import { Sgke060dComponent } from './pages/sgke060d/pages/sgke060d/sgke060d.component';
import { Sgke070dRegistComponent } from './pages/sgke070d/components/sgke070d-regist/sgke070d-regist.component';
import { Sgke070dComponent } from './pages/sgke070d/pages/sgke070d/sgke070d.component';
import { Sgke080dResultComponent } from './pages/sgke080d/components/sgke080d-result/sgke080d-result.component';
import { Sgke080dComponent } from './pages/sgke080d/pages/sgke080d/sgke080d.component';
import { Sgke090dConditionComponent } from './pages/sgke090d/components/sgke090d-condition/sgke090d-condition.component';
import { Sgke090dResultComponent } from './pages/sgke090d/components/sgke090d-result/sgke090d-result.component';
import { Sgke090dComponent } from './pages/sgke090d/pages/sgke090d/sgke090d.component';
import { Sgke100dResultComponent } from './pages/sgke100d/components/sgke100d-result/sgke100d-result.component';
import { Sgke100dComponent } from './pages/sgke100d/pages/sgke100d/sgke100d.component';
import { Sgke110dDialogComponent } from './pages/sgke110d/components/sgke110d-dialog/sgke110d-dialog.component';
import { Sgke110dInfoComponent } from './pages/sgke110d/components/sgke110d-info/sgke110d-info.component';
import { Sgke110dComponent } from './pages/sgke110d/pages/sgke110d/sgke110d.component';
import { Sgke120dSearchConditionComponent } from './pages/sgke120d/components/sgke120d-search-condition/sgke120d-search-condition.component';
import { Sgke120dSearchResultComponent } from './pages/sgke120d/components/sgke120d-search-result/sgke120d-search-result.component';
import { Sgke120dComponent } from './pages/sgke120d/pages/sgke120d/sgke120d.component';
import { Sgke130dBasicInfoComponent } from './pages/sgke130d/components/sgke130d-basic-info/sgke130d-basic-info.component';
import { Sgke130dBikoranComponent } from './pages/sgke130d/components/sgke130d-bikoran/sgke130d-bikoran.component';
import { Sgke130dKouzaDepositreportMeisaiComponent } from './pages/sgke130d/components/sgke130d-kouza-depositreport-meisai/sgke130d-kouza-depositreport-meisai.component';
import { Sgke130dRcvmnyFeeMeisaiComponent } from './pages/sgke130d/components/sgke130d-rcvmny-fee-meisai/sgke130d-rcvmny-fee-meisai.component';
import { Sgke130dReceivemoneyyoteiMeisaiComponent } from './pages/sgke130d/components/sgke130d-receivemoneyyotei-meisai/sgke130d-receivemoneyyotei-meisai.component';
import { Sgke130dReconciliationResultComponent } from './pages/sgke130d/components/sgke130d-reconciliation-result/sgke130d-reconciliation-result.component';
import { Sgke130dComponent } from './pages/sgke130d/pages/sgke130d/sgke130d.component';
import { Sgke140dDialogComponent } from './pages/sgke140d/components/sgke140d-dialog/sgke140d-dialog.component';
import { Sgke140dInfoComponent } from './pages/sgke140d/components/sgke140d-info/sgke140d-info.component';
import { Sgke140dComponent } from './pages/sgke140d/pages/sgke140d/sgke140d.component';
import { Sgke150dConditionComponent } from './pages/sgke150d/components/sgke150d-condition/sgke150d-condition.component';
import { Sgke150dComponent } from './pages/sgke150d/pages/sgke150d/sgke150d.component';
import { Sgke160dSearchConditionComponent } from './pages/sgke160d/components/sgke160d-search-condition/sgke160d-search-condition.component';
import { Sgke160dSearchResultComponent } from './pages/sgke160d/components/sgke160d-search-result/sgke160d-search-result.component';
import { Sgke160dComponent } from './pages/sgke160d/pages/sgke160d/sgke160d.component';
import { Sgke300dSearchConditionComponent } from './pages/sgke300d/components/sgke300d-search-condition/sgke300d-search-condition.component';
import { Sgke300dSearchResultComponent } from './pages/sgke300d/components/sgke300d-search-result/sgke300d-search-result.component';
import { Sgke300dComponent } from './pages/sgke300d/pages/sgke300d/sgke300d.component';
import { Sgke310dConditionComponent } from './pages/sgke310d/components/sgke310d-condition/sgke310d-condition.component';
import { Sgke310dResultComponent } from './pages/sgke310d/components/sgke310d-result/sgke310d-result.component';
import { Sgke310dComponent } from './pages/sgke310d/pages/sgke310d/sgke310d.component';
import { Sgke320dConditionComponent } from './pages/sgke320d/components/sgke320d-condition/sgke320d-condition.component';
import { Sgke320dResultComponent } from './pages/sgke320d/components/sgke320d-result/sgke320d-result.component';
import { Sgke320dComponent } from './pages/sgke320d/pages/sgke320d/sgke320d.component';
import { Sgke330dConditionComponent } from './pages/sgke330d/components/sgke330d-condition/sgke330d-condition.component';
import { Sgke330dResultComponent } from './pages/sgke330d/components/sgke330d-result/sgke330d-result.component';
import { Sgke330dComponent } from './pages/sgke330d/pages/sgke330d/sgke330d.component';
import { Sgke340dConditionComponent } from './pages/sgke340d/components/sgke340d-condition/sgke340d-condition.component';
import { Sgke340dComponent } from './pages/sgke340d/pages/sgke340d/sgke340d.component';
import { Sgke350dConditionComponent } from './pages/sgke350d/components/sgke350d-condition/sgke350d-condition.component';
import { Sgke350dResultComponent } from './pages/sgke350d/components/sgke350d-result/sgke350d-result.component';
import { Sgke350dComponent } from './pages/sgke350d/pages/sgke350d/sgke350d.component';
import { Sgke360dButtonAreaComponent } from './pages/sgke360d/components/sgke360d-button-area/sgke360d-button-area.component';
import { Sgke360dCustomerInfoComponent } from './pages/sgke360d/components/sgke360d-customer-info/sgke360d-customer-info.component';
import { Sgke360dGuidingvalueInputComponent } from './pages/sgke360d/components/sgke360d-guidingvalue-input/sgke360d-guidingvalue-input.component';
import { Sgke360dInspectionTreatmentComponent } from './pages/sgke360d/components/sgke360d-inspection-treatment/sgke360d-inspection-treatment.component';
import { Sgke360dLastConfirmationComponent } from './pages/sgke360d/components/sgke360d-last-confirmation/sgke360d-last-confirmation.component';
import { Sgke360dPreCheckComponent } from './pages/sgke360d/components/sgke360d-pre-check/sgke360d-pre-check.component';
import { Sgke360dRegistAreaComponent } from './pages/sgke360d/components/sgke360d-regist-area/sgke360d-regist-area.component';
import { Sgke360dResultsComponent } from './pages/sgke360d/components/sgke360d-results/sgke360d-results.component';
import { Sgke360dSafetyComponent } from './pages/sgke360d/components/sgke360d-safety/sgke360d-safety.component';
import { Sgke360dComponent } from './pages/sgke360d/pages/sgke360d/sgke360d.component';
import { Sgke370dDialogComponent } from './pages/sgke370d/components/sgke370d-dialog/sgke370d-dialog.component';
import { Sgke370dComponent } from './pages/sgke370d/pages/sgke370d/sgke370d.component';
import { Sgke380dSearchConditionComponent } from './pages/sgke380d/components/sgke380d-search-condition/sgke380d-search-condition.component';
import { Sgke380dSearchResultComponent } from './pages/sgke380d/components/sgke380d-search-result/sgke380d-search-result.component';
import { Sgke380dComponent } from './pages/sgke380d/pages/sgke380d/sgke380d.component';
import { Sgke390dDialogComponent } from './pages/sgke390d/components/sgke390d-dialog/sgke390d-dialog.component';
import { Sgke390dInfoComponent } from './pages/sgke390d/components/sgke390d-info/sgke390d-info.component';
import { Sgke390dComponent } from './pages/sgke390d/pages/sgke390d/sgke390d.component';
import { Sgke400dConditionComponent } from './pages/sgke400d/components/sgke400d-condition/sgke400d-condition.component';
import { Sgke400dResultComponent } from './pages/sgke400d/components/sgke400d-result/sgke400d-result.component';
import { Sgke400dComponent } from './pages/sgke400d/pages/sgke400d/sgke400d.component';
import { Sgke410dConditionComponent } from './pages/sgke410d/components/sgke410d-condition/sgke410d-condition.component';
import { Sgke410dResultComponent } from './pages/sgke410d/components/sgke410d-result/sgke410d-result.component';
import { Sgke410dComponent } from './pages/sgke410d/pages/sgke410d/sgke410d.component';
import { SgKeMainRoutingModule } from './sg-ke-main-routing.module';

@NgModule({
  declarations: [
    NumberInputDirective,
    Sgke010dComponent,
    Sgke010dSearchConditionComponent,
    Sgke010dSearchResultComponent,
    Sgke020dComponent,
    Sgke020dBusinessTypeComponent,
    Sgke030dComponent,
    Sgke030dViewComponent,
    Sgke030dSearchResultComponent,
    Sgke040dComponent,
    Sgke040dViewComponent,
    Sgke040dSearchConditionComponent,
    Sgke040dSearchResultComponent,
    Sgke050dComponent,
    Sgke050dDialogComponent,
    Sgke050dRegistComponent,
    Sgke060dComponent,
    Sgke060dRegistComponent,
    Sgke070dComponent,
    Sgke070dRegistComponent,
    Sgke080dComponent,
    Sgke080dResultComponent,
    Sgke090dComponent,
    Sgke090dConditionComponent,
    Sgke090dResultComponent,
    Sgke100dComponent,
    Sgke100dResultComponent,
    Sgke110dComponent,
    Sgke110dDialogComponent,
    Sgke110dInfoComponent,
    Sgke120dComponent,
    Sgke120dSearchConditionComponent,
    Sgke120dSearchResultComponent,
    Sgke130dComponent,
    Sgke130dBasicInfoComponent,
    Sgke130dReconciliationResultComponent,
    Sgke130dReceivemoneyyoteiMeisaiComponent,
    Sgke130dKouzaDepositreportMeisaiComponent,
    Sgke130dRcvmnyFeeMeisaiComponent,
    Sgke130dBikoranComponent,
    Sgke140dComponent,
    Sgke140dDialogComponent,
    Sgke140dInfoComponent,
    Sgke150dComponent,
    Sgke150dConditionComponent,
    Sgke160dComponent,
    Sgke160dSearchConditionComponent,
    Sgke160dSearchResultComponent,
    Sgke300dComponent,
    Sgke300dSearchConditionComponent,
    Sgke300dSearchResultComponent,
    Sgke310dComponent,
    Sgke310dConditionComponent,
    Sgke310dResultComponent,
    Sgke320dComponent,
    Sgke320dConditionComponent,
    Sgke320dResultComponent,
    Sgke330dComponent,
    Sgke330dConditionComponent,
    Sgke330dResultComponent,
    Sgke340dComponent,
    Sgke340dConditionComponent,
    Sgke350dComponent,
    Sgke350dConditionComponent,
    Sgke350dResultComponent,
    Sgke360dComponent,
    Sgke360dCustomerInfoComponent,
    Sgke360dRegistAreaComponent,
    Sgke360dButtonAreaComponent,
    Sgke360dResultsComponent,
    Sgke360dInspectionTreatmentComponent,
    Sgke360dGuidingvalueInputComponent,
    Sgke360dSafetyComponent,
    Sgke360dLastConfirmationComponent,
    Sgke360dPreCheckComponent,
    Sgke370dComponent,
    Sgke370dDialogComponent,
    Sgke380dComponent,
    Sgke380dSearchConditionComponent,
    Sgke380dSearchResultComponent,
    Sgke390dComponent,
    Sgke390dDialogComponent,
    Sgke390dInfoComponent,
    Sgke400dComponent,
    Sgke400dConditionComponent,
    Sgke400dResultComponent,
    Sgke410dComponent,
    Sgke410dConditionComponent,
    Sgke410dResultComponent,
  ],
  imports: [
    SharedModule,
    SgKeMainRoutingModule,
    SgBaseSharedModule,
  ]
})
export class SgKeMainModule { }

